import { Component, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import {
  SaasProductsService,
  ModuleGroup,
} from '../../services/saas-products.service';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-modulos',
  standalone: true,
  imports: [CommonModule, RouterLink, ButtonModule],
  templateUrl: './modulos.component.html',
  styleUrl: './modulos.component.scss',
})
export class ModulosComponent {
  private saasProducts = inject(SaasProductsService);
  private langService = inject(LanguageService);

  groups: ModuleGroup[] = [];
  isLoading = true;

  constructor() {
    // El idioma viene del switcher runtime (LanguageService), NO de LOCALE_ID
    // (estático del build = 'en'). El effect recarga el CMS al cambiar de idioma
    // y al resolverse el idioma en el arranque (?lang / localStorage).
    effect(() => {
      const lang = this.langService.currentLang();
      void this.load(lang);
    });
  }

  private async load(lang: string): Promise<void> {
    this.isLoading = true;
    this.groups = await this.saasProducts.getModulesByCategory(lang);
    this.isLoading = false;
  }
}
